import React, { useRef, useState, useEffect } from "react";
import useOutsideClick from "../../../utils/hooks/useOutsideClickHook";
import { IoEllipsisVertical } from "react-icons/io5";
import { Overlay } from "react-bootstrap";
import { ArchiveBlackOutlineIcon } from "../../../assets/svgs/SvgsImg";
import { fetchScreenTranslations } from "../../../utils/helpers/translations";

const ArchiveChatOptions = ({ onShowArchive }) => {
  const refOptions = useRef();
  const refOverlay = useRef();

  const [fetchTransChatList, setFetchTransChatList] = useState({});
  const t = (key) => fetchTransChatList?.[key] || "";

  useEffect(() => {
    fetchScreenTranslations("Chat").then((res) => {
      setFetchTransChatList(res);
    });
  }, []);

  const [isMenuOpen, setMenuOpen] = useState(false);

  const toggleMenuOpen = (event) => {
    event.stopPropagation();
    event.preventDefault();
    setMenuOpen((p) => !p);
  };

  const onMenuClick = (event, type) => {
    event.stopPropagation();
    event.preventDefault();
    switch (type) {
      case "ARCHIVE":
        onShowArchive && onShowArchive();
        setMenuOpen(false);
        break;
    }
  };

  useOutsideClick(() => {
    setMenuOpen(false);
  }, [refOptions, refOverlay]);

  return (
    <>
      <div
        className="archive-chat-option-container"
        ref={refOptions}
        onClick={toggleMenuOpen}
      >
        <IoEllipsisVertical fontSize={30} color="#A5A5A5" />
      </div>
      <Overlay
        target={refOptions.current}
        show={isMenuOpen}
        placement="bottom-end"
        offset={[20, -30]}
      >
        {(props) => (
          <div {...props} style={{ ...props.style }}>
            <div className="archive-menu-options-container" ref={refOverlay}>
              <div className="archive-menu-close-container">
                <div
                  className="archive-menu-close-button"
                  onClick={toggleMenuOpen}
                >
                  <IoEllipsisVertical fontSize={30} color="#A5A5A5" />
                </div>
              </div>
              <div
                className="archive-menu-option-item"
                onClick={(e) => onMenuClick(e, "ARCHIVE")}
              >
                <ArchiveBlackOutlineIcon />
                {/* View Archive */}
                {t("View Archieve")}
              </div>
            </div>
          </div>
        )}
      </Overlay>
    </>
  );
};

export default ArchiveChatOptions;
